/* Plan & credits (API: api/src/modules/billing/README.md). Other features show a cost estimate before
   costly runs with `CostEstimate` / `useCostEstimate` from './estimate' (see that file). */
import { lazy } from 'react';
import { CreditCard } from 'lucide-react';
import { defineFeature } from '../../app/feature';

export default defineFeature({
  id: 'billing',
  title: 'Plan & credits',
  short: 'Plan',
  icon: CreditCard,
  group: 'Account',
  route: '/billing',
  order: 10,
  screen: lazy(() => import('./Screen.tsx')),
  commands: [
    { id: 'change', title: 'Change how I pay for usage', to: '/billing?change=1', keywords: ['mode', 'byok', 'pay as you go', 'subscription', 'tier', 'plan'] },
    { id: 'keys', title: 'Manage my API keys (BYOK)', to: '/billing?keys=1', keywords: ['byok', 'key', 'anthropic', 'openai'] },
    { id: 'usage', title: 'Usage and invoices', to: '/billing', keywords: ['credits', 'spend', 'invoice', 'receipt', 'csv'] },
  ],
  capabilities: ['BILL-01', 'BILL-02', 'BILL-03', 'BILL-04', 'BILL-05', 'BILL-06', 'MODEL-10', 'SAFE-09'],
});
